var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:(_vm.styles),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.symbolId,"fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }